import { Route, Routes } from 'react-router-dom';
import ManageUser from 'components/ManageUser/ManageUser';
import Login from 'components/Auth/Login';
import Workshop from 'components/Workshop/workshop';
import CreateWorkshop from 'components/Workshop/CreateWorkshop';
import WorkshopUpdate from 'components/Workshop/WorkshopUpdate';
import WorkshopDetails from 'components/Workshop/WorkshopDetails';
import ProtectedRoute from 'components/Auth/ProtectedRoute';
import Consultancy from 'components/Consultancy/Consultancy';
import CreateMember from 'components/Consultancy/CreateMember';
import Product from 'components/Product/Product';
import ManageProduct from 'components/Product/ManageProduct';
import CreateProduct from 'components/Product/CreateProduct';
import Dashboard from 'components/Dashboard/Dashboard';
import Inquiry from 'components/Inquiry/Inquiry';
import Survey from 'components/survey/Survey';
import HealthChecker from "components/HealthChecker/HealthChecker";
import React from 'react';

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route
                path="/ManageUser"
                element={
                    <ProtectedRoute>
                        <ManageUser />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/workshop"
                element={
                    <ProtectedRoute>
                        <Workshop />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/create workshop"
                element={
                    <ProtectedRoute>
                        <CreateWorkshop />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/workshops/edit/:slug"
                element={
                    <ProtectedRoute>
                        <WorkshopUpdate />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/workshopDetails/:slug"
                element={
                    <ProtectedRoute>
                        <WorkshopDetails />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/consultancy"
                element={
                    <ProtectedRoute>
                        <Consultancy />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/create member"
                element={
                    <ProtectedRoute>
                        <CreateMember />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/product"
                element={
                    <ProtectedRoute>
                        <Product />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/product/:slug"
                element={
                    <ProtectedRoute>
                        <ManageProduct />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/create product"
                element={
                    <ProtectedRoute>
                        <CreateProduct />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/inquiry"
                element={
                    <ProtectedRoute>
                        <Inquiry />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/survey"
                element={
                    <ProtectedRoute>
                        <Survey />
                    </ProtectedRoute>
                }   
            />

            <Route
                path="/healthchecker"
                element={
                    <ProtectedRoute>
                        <HealthChecker />
                    </ProtectedRoute>
                }
            />

        </Routes>
    );
};

export default AppRoutes;
